import React, { useState, useEffect } from "react";
import { Button, FormInput } from "@fastlane-llc/lossexpress-ui-kit";

import { Dropdown } from "primereact/dropdown";

import { useForm } from "react-hook-form";

import { fetchCurrentUsersList } from "../../services/users";

import Modal from "../Modal";
import "./ReassignModal.css";

const ReassignModal = ({
  packet,
  close = () => {},
  reassignPacket = () => {}
}) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const { register, handleSubmit, setValue, watch } = useForm({
    mode: "onBlur"
  });

  const { stopNotifications } = watch();

  useEffect(() => {
    const returnFetch = async () => {
      const u = await fetchCurrentUsersList();
      setUsers(u);
      const packetUser = u.find(user => user.userId === packet.userId);
      setSelectedUser(packetUser);
    };

    returnFetch();
    setValue("stopNotifications", true);
  }, [setUsers, setValue, packet.userId]);

  const newAssignment = async () => {
    await reassignPacket(selectedUser, stopNotifications);
  };

  const onSelectChange = () => obj => {
    setValue("user", obj.value);
    const selectedUser = users.find(user => user.userId === obj.value);
    setSelectedUser(selectedUser);
  };

  return (
    <Modal onClose={close} title="Re-assign Packet">
      <p>
        This packet is currently managed by:{" "}
        <span className="ManagedByName">{packet.name}</span>. Please select a
        user from the list below to reassign the packet to.
      </p>
      <form onSubmit={handleSubmit(newAssignment)}>
        {users.length > 0 && (
          <Dropdown
            className="ReassignDropdown"
            options={users.map(user => ({
              value: user.userId,
              label: user.name
            }))}
            value={selectedUser?.userId || packet?.userId}
            onChange={onSelectChange()}
            data-testid="ReassignDropdown"
            appendTo="self"
          />
        )}

        <FormInput
          type="checkbox"
          name="stopNotifications"
          value={stopNotifications}
          onChange={setValue}
          register={register}
          label={`Opt ${packet.name} out of notifications as well`}
        />

        <div className="ModalBottomButtonsLeft">
          <Button>Reassign Packet</Button>
          <Button color="red" invert onClick={close}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ReassignModal;
